import React from "react";
import Logo from "../Assets/lume.png";
import { SiLinkedin } from "react-icons/si";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";
import './Footer.css';

function Copyright(props) {
  return (
    <Typography fontWeight={545} color="#e0e0e0" {...props}>
      {'Copyright © '}
        Lume Solutions Limited
      {' '}
      {new Date().getFullYear()}
      {'. All rights reserved.'}
    </Typography>
  );
}

const Footer = () => {
  const navigate = useNavigate();

  const handlePricingClick = () => {
    navigate("/pricing");
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Company Info Section */}
        <div className="footer-column footer-company">
          <div className="footer-logo-container">
            <img src={Logo} alt="Lume Solutions Logo" />
          </div>
          <p className="footer-description">
            Powering smarter lending with AI-driven insights and analytics for businesses in Africa.
          </p>
          <div className="footer-social-icons">
            <a 
              href="https://www.linkedin.com/company/lume-solutions-co/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="LinkedIn"
            >
              <SiLinkedin />
            </a>
            <a
              href="https://wa.me/254716060606"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="WhatsApp"
            >
              <WhatsAppIcon />
            </a>
            <a 
              href="mailto:info@lumesolutions.co"
              className="social-icon"
              aria-label="Email"
            >
              <MailOutlineIcon />
            </a>
          </div>
        </div>

        {/* Quick Links Section */}
        <div className="footer-column">
          <h3 className="footer-column-title">Quick Links</h3>
          <ul className="footer-links">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about-us">About Us</a>
            </li>
            <li>
              <a href="/faq">FAQ</a>
            </li>
            <li>
              <a href="/book-now">Book A Demo</a>
            </li>
          </ul>
        </div>

        {/* Resources Section */}
        <div className="footer-column">
          <h3 className="footer-column-title">Resources</h3>
          <ul className="footer-links">
            <li>
              <span>API Docs</span>
            </li>
            <li>
              <span>Developers</span>
            </li>
            <li>
              <span>Integrations</span>
            </li>
            <li>
              <a href="mailto:info@lumesolutions.co">Support</a>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-column footer-contact">
          <h3 className="footer-column-title">Contact Us</h3>
          <div className="contact-info">
            <div className="contact-item">
              <LocationOnIcon className="contact-icon" />
              <div>
                <p>8th Floor, Reliable Towers</p>
                <p>Mogotio Road, Westlands</p>
                <p>Nairobi, Kenya</p>
                <p className="contact-item-small">P.O BOX 26541-00504</p>
              </div>
            </div>
            <div className="contact-item">
              <MailOutlineIcon className="contact-icon" />
              <a href="mailto:info@lumesolutions.co">info@lumesolutions.co</a>
            </div>
            <div className="contact-item">
              <PhoneIcon className="contact-icon" />
              <a href="tel:+254716060606">+254 700 201 201</a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <Copyright />
          <div className="footer-legal-links">
            <span onClick={() => navigate('/privacy-policy')}>
              Privacy Policy
            </span>
            <span className="separator">|</span>
            <span onClick={() => navigate('/terms-and-conditions')}>
              Terms & Conditions
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
